<template>
  <div>
    <h1 class="text-h2 pb-16">Great work! Let's share your needs with sitters</h1>
    <div class="flex items-start gap-8 mb-16">
      <span class="text-20 leading-none flex-shrink-0">💡</span>
      <p class="text-body leading-6">Families who share their needs are <strong>2.5x</strong> more likely to find a match.</p>
    </div>
    <NoteBox v-if="!skipReviewExperiment" header="What's next?">
      <ol class="leading-8 text-body-2 list-decimal pl-20 mt-8 space-y-8">
        <li>Review and share your needs for free</li>
        <li>Interested sitters will reach out</li>
        <li v-if="isBasic">Upgrade to Premium to move forward with your matches</li>
        <li v-else>Connect with sitters who meet your needs</li>
      </ol>
    </NoteBox>
  </div>
</template>

<script lang="ts">
import NoteBox from '@/components/note_box/NoteBox.vue';
import { isOn } from '@/lib/growthbook';

export default {
  name: 'JobPostConfirmTransitionText',
  components: {
    NoteBox,
  },
  props: {
    isAiGenerated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isBasic(): boolean {
      return this.$store.getters['account/getAccount'].isBasic?.() || false;
    },
    skipReviewExperiment(): boolean {
      return isOn('skip-job-post-review');
    },
  },
};
</script>
